// extracted by mini-css-extract-plugin
module.exports = {"scoreBoard":"ScoreBoard_scoreBoard__2XOVV","dataBoard":"ScoreBoard_dataBoard__1No0n","theTable":"ScoreBoard_theTable__3S9Na"};